import { EyeOutlined } from '@ant-design/icons';
import { ViewResolver } from '@Components/ViewResolver';
import { ViewWidget } from '@Components/ViewWidget';
import Flex from 'antd/es/flex';
import classNames from 'classnames';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './TenderInfoBtn.module.css';
import TenderInfo from '../../components/TenderInfo/TenderInfo';

interface TenderInfoBtnProps {}
const TenderInfoBtn: FC<TenderInfoBtnProps> = () => {
  const { tenderId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Flex
        className={classNames(
          styles['header-btn'],
          'header-action-component trojan-neumorphism-box trojan-neumorphism-box-shadow'
        )}
        onClick={() => {
          setIsModalOpen(true);
        }}
        gap="small"
      >
        <span className="user-name">Tender {tenderId}</span>
        <EyeOutlined />
      </Flex>
      {tenderId && (
        <ViewWidget
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          height={396}
        >
          <ViewResolver
            desktop={<TenderInfo tenderId={tenderId} />}
            mobile={null}
          />
        </ViewWidget>
      )}
    </>
  );
};

export default TenderInfoBtn;
